import React from "react";
import { CommunicationContainer } from "../../../containers";
import { withAppLayout } from "../../../hoc";

const Communication = (props) => {
  return <CommunicationContainer {...props} />;
};

export default Communication;
